import DealersPage from "./DealersPage";

export default DealersPage;
